import * as React from "react"
import { connect } from "react-redux"

import { ActionType } from "@tenforce/toolbox-button-push-react"

import { GlobalState } from "../../../store"
import OldUIContext from "../../../olduicontext"

import { getPrimaryActions, getSecondaryActions } from "../selectors"
import { DispatchProps, mapDispatchToProps } from "../actions"

import BookmarkButton from "../../bookmarks/components/BookmarkButton"
import ContextMenuAction from "../../common/contextmenu/components/ContextMenuAction"
import ShareButton from "../../common/resource/ShareButton"
import Separator from "../../common/Separator"

import { Labels } from "../../../util/Translations"
import { ICardViewItem } from "../index"
import { IButton, ICallButton } from "../../common/contextmenu"

export interface OwnProps {
    item: ICardViewItem
}

interface StateProps {
    primaryActions: IButton[]
    secondaryActions: IButton[]
}

type Props = OwnProps & StateProps & DispatchProps

export class ContextMenuModalContent extends React.Component<Props> {
    static contextType = OldUIContext
    context: React.ContextType<typeof OldUIContext>

    render(): JSX.Element {
        const { item, primaryActions, secondaryActions } = this.props
        const { contextMenu } = item

        if (!contextMenu || !contextMenu.isShown) {
            return <></>
        }

        const { id, number, title } = item
        const {
            AddBookmark,
            ItemDetailsCopiedToClipboard,
            RemoveBookmark,
            ShareButtonTooltip,
        } = Labels

        const bookmarkButtonId = contextMenu.bookmarkButton?.bookmarkButtonId
        const shareUrl = `${window.location.origin}${window.location.pathname}/${id}`

        return (
            <>
                <div className="tw-p-2">
                    {primaryActions.map((button: IButton) => {
                        return (
                            <ContextMenuAction
                                button={button}
                                executeCallAction={this.executeCallAction}
                                key={button.uuid}
                            />
                        )
                    })}

                    <ShareButton
                        buttonId={`shareButton${id}`}
                        numberText={number}
                        resourceTitle={title}
                        showCaption={true}
                        successMessage={ItemDetailsCopiedToClipboard}
                        tooltip={ShareButtonTooltip}
                        url={shareUrl}
                    />

                    {!!bookmarkButtonId && (
                        <BookmarkButton
                            actionType={ActionType.block}
                            addBookmarkLabel={AddBookmark}
                            bookmarkButtonId={bookmarkButtonId}
                            extraClasses="tw-p-2"
                            removeBookmarkLabel={RemoveBookmark}
                            showCaption={true}
                        />
                    )}
                </div>

                {secondaryActions.length > 0 && (
                    <>
                        <Separator />
                        <div className="tw-py-2">
                            {secondaryActions.map((button: IButton) => {
                                return (
                                    <ContextMenuAction
                                        button={button}
                                        executeCallAction={
                                            this.executeCallAction
                                        }
                                        extraClasses="tw-py-2 tw-px-4"
                                        key={button.uuid}
                                    />
                                )
                            })}
                        </div>
                    </>
                )}
            </>
        )
    }

    executeCallAction = (event: React.MouseEvent, button: IButton): void => {
        event.preventDefault()
        const {
            item: { id },
            executeAction,
        } = this.props
        executeAction(id, button as ICallButton)
    }
}

const mapStateToProps = (state: GlobalState, props: OwnProps): StateProps => ({
    primaryActions: getPrimaryActions(state.cardView, props),
    secondaryActions: getSecondaryActions(state.cardView, props),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ContextMenuModalContent)
